<template>
  <div class="d-flex">
    <router-link v-if="editPath" :to="editPath">
      <v-img src="/icons/crayon.png" width="30" class="mr-2" />
    </router-link>
    <v-img
      v-else
      src="/icons/crayon.png"
      max-width="25"
      class="mr-2"
      style="cursor: pointer"
      @click="edit"
    />
    <v-img
      src="/icons/delete.png"
      max-width="20"
      class="mr-2 "
      style="cursor: pointer"
      @click="deleteAction"
    />
  </div>
</template>
<script>
export default {
  name: "EditDelete",
  props: {
    editPath: {
      type: Object,
      required: false,
    },
  },
  methods: {
    slotPassed() {
      return !!this.$slots.default[0].text.length
    },
    edit() {
      this.$emit("edit")
    },
    deleteAction() {
      if (confirm(this.$t("common.delete_confirm"))) {
        this.$emit("delete")
      }
    },
  },
}
</script>
